import { cn } from '@lib/util/cn';

type DotsNavProps = {
  snapCount: number;
  selectedIndex: number;
};

const DotsNav = ({ snapCount, selectedIndex }: DotsNavProps) =>
  snapCount <= 1 ? null : (
    <div aria-hidden="true" className="flex items-center gap-2 p-1">
      {Array.from({ length: snapCount }, (_, i) => i).map((i) => (
        <span
          key={i}
          className={cn(
            'h-2.5 rounded-full transition-all duration-300',
            i === selectedIndex
              ? 'w-[27px] bg-brand-interactive-600'
              : 'w-2.5 bg-brand-neutral-300',
          )}
        />
      ))}
    </div>
  );

export default DotsNav;
